import { DASHBOARD_CONTENT_CONTAINER_ID } from '@/router/pageConst'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
// import ProfessorProjectDetailPage from '../ProfessorProjectDetailPage/ProfessorProjectDetailPage'
import ProfessorProjectPageContent from './components/ProfessorProjectPageContent/ProfessorProjectPageContent'

function ProfessorProjectPage() {
  const location = useLocation()
  const isDetail = location.state && location.state.id
  const scorllTop = useRef(0)

  useEffect(() => {
    const dashboardContent = document.getElementById(DASHBOARD_CONTENT_CONTAINER_ID)!
    if (isDetail) {
      dashboardContent.scrollTo({ top: 0 })
    } else {
      dashboardContent.scrollTo({ top: scorllTop.current })
    }
    const handleScroll = (e: Event) => {
      if (!isDetail) {
        const target = e.target as HTMLElement
        scorllTop.current = target.scrollTop
      }
    }
    dashboardContent.addEventListener('scroll', handleScroll)
    return () => {
      dashboardContent.removeEventListener('scroll', handleScroll)
    }
  }, [isDetail])

  return (
    <>
      {/* <div style={{ display: isDetail ? 'none' : 'block', opacity: isDetail ? 0 : 1 }}></div> */}
      <ProfessorProjectPageContent />
      {/* {isDetail && <ProfessorProjectDetailPage />} */}
    </>
  )
}

export default ProfessorProjectPage
